module.exports = __webpack_public_path__ + "img/integration7.1745420f.webp";